import { Component, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { CommonModule } from '@angular/common';
import { FuseCardComponent } from '@fuse/components/card';
import { FooterType03Component } from "../../../../layout/common/footer/footer-type03/footer-type03.component";


@Component({
  selector: 'articles-type03',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, MatIconModule, HeadingSectionType01Component, MatIconModule, FuseCardComponent, FooterType03Component],
  templateUrl: './articles-type03.component.html',
  styleUrl: './articles-type03.component.scss'
})
export class ArticlesType03Component {

  public view: any = {
    title: ''
  }

  constructor(public _tfmService: TFMService) {
    
    this._tfmService.getPages().then(res => {
      this.view.pages = res;

      this._tfmService.filterBundles({id:this.view.id, rateType:'pps', isActive:true}, false).then(res => {
        this.view.bundle = res.content && res.content.length > 0 ? res.content[0] : null;
        this.view.images = this.view.bundle.imageUrls;
        
        this.view.headerImage = this.view.images[this._tfmService.getRandom(0, this.view.images.length)];

        // this._tfmService.log(this.view);
      });
      this._tfmService.log(res);
    });
  }
  ngOnInit(): void {
      this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log(this.view);

      });
          this._tfmService.getArticles().then(res => {
            this.view.articles = res;
            this._tfmService.log(this.view.articles)


      });
    }
}
